import { render, staticRenderFns } from "./Fankuiliebiao.vue?vue&type=template&id=17abdb6b&scoped=true&"
import script from "./Fankuiliebiao.vue?vue&type=script&lang=js&"
export * from "./Fankuiliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Fankuiliebiao.vue?vue&type=style&index=0&id=17abdb6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17abdb6b",
  null
  
)

export default component.exports